/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unescaped-entities */
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Loader } from 'ypf-pas-general-ui-components';
import { BsChevronLeft } from 'react-icons/bs';
import { VscCopy } from 'react-icons/vsc';
import { Col, Row } from 'react-bootstrap';

import { useDetailServiceRequest } from '../../../context/DetailServiceRequestProvider';
import PillStatus from '../../../components/PillStatus/PillStatus';
import useRequestDetailPermissions from '../../../hooks/useRequestDetailPermissions';
import { assignmentTypeEnum } from '../../../utils/dataStatus';
import { aprobador, consultaServicios, solicitante } from '../../../security/constantsRols';
import { checkRol } from '../../../security';

import UbicationCard from './UbicationCard/UbicationCard';
import TabsDetail from './TabsDetail/TabsDetail';
import Description from './Description/Description';

import './DetailServiceRequest.scss';

const DetailServiceRequest = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('solicitado');

  const { details, loading } = useDetailServiceRequest();
  const { id } = useParams();

  const showLocationCard = details;

  const accepted = details?.proveedoresAceptados;
  const reject = details?.proveedoresRechazados;
  const totally = details?.proveedoresTotales;
  const responsetotally = accepted + reject === totally;
  const pastTime = details?.pasoFechaRespuesta;
  const styleJustify = pastTime ? 'header-detail-justify' : 'header-detail';
  const idStatus = details?.estadoEnum;
  const codigo = details?.numero;
  const isAsds = details?.tipoAsignacion?.id === assignmentTypeEnum.Automatica;
  const isOyM = details?.tipoUbicacion.id > 2;

  const { permissions } = useRequestDetailPermissions({
    notifyTo: details?.tipoNotificacionEnum,
    isASDS: isAsds,
    isOyM
  });

  return (
    <div className="container container-detail-service-request">
      {loading && <Loader show text="CARGANDO ..." />}
      <div className={`${styleJustify}`}>
        <div className="title">
          <Button
            colorIcon="primary"
            icon={BsChevronLeft}
            onClick={() => {
              history.push(
                checkRol(aprobador) && !checkRol(solicitante) && !checkRol(consultaServicios)
                  ? '/approver'
                  : '/'
              );
            }}
            type="button"
            variant="white"
            widthButton="42px"
          />
          <h2>Solicitud de servicio N° {codigo}</h2>
        </div>
        <Row className="align-items-center">
          <Col md={5} sm={5}>
            <PillStatus
              accepted={accepted}
              idStatus={idStatus}
              pastTime={pastTime}
              reject={reject}
              responsetotally={responsetotally}
              totally={totally}
            />
          </Col>
          {permissions.replySDS && !isOyM && !details?.sinEventoAsignado && (
            <Col md={6} sm={6}>
              <button
                className={`reply-sds-button ${pastTime ? 'mx-3' : ''}`}
                onClick={() => {
                  history.push({
                    pathname: '/createMultiple',
                    previusPath: `detail/${id}`,
                    idSDSToReply: id
                  });
                }}
                type="button"
              >
                <span>Replicar</span>
                <VscCopy />
              </button>
            </Col>
          )}
        </Row>
      </div>
      {showLocationCard && (
        <>
          <UbicationCard
            details={details}
            idStatus={idStatus}
            tpyeAndObjectImputationPermissions={permissions.typeAndObjectImputation}
          />
          <Description details={details} setActiveTab={setActiveTab} />
        </>
      )}
      <TabsDetail
        activeTab={activeTab}
        details={details}
        idStatus={idStatus}
        isOyM={isOyM}
        permissions={permissions}
        setActiveTab={setActiveTab}
      />
    </div>
  );
};

export default DetailServiceRequest;
